import React from "react";
import { useNavigate } from "react-router-dom";

export default function SecretEntry() {
  const navigate = useNavigate();

  return (
    <div className="h-screen flex items-center justify-center bg-black">

      {/* 👇 Your clickable emoji / face */}
      <div
        onClick={() => navigate("/x-admin")}
        className="text-7xl cursor-pointer hover:scale-110 transition"
      >
        😎
      </div>

    </div>
  );
}